module.exports = __webpack_public_path__ + "static/media/change_item_details.9fb33693.svg";